import React from "react";
import styled from "styled-components";
import { EditableInput } from "@shoothill/core";
import { theme } from "./AppTheme";

export const CustomInput: any = styled(EditableInput)`
    .MuiInputBase-root {
        @media (max-width: 768px) {
            font-size: 16px !important;
            margin-bottom: 10px;
        }
    }
    .MuiInputLabel-root {
        @media (max-width: 768px) {
            position: relative;
            margin-bottom: -10px;
            white-space: normal;
            font-size: 16px !important;
        }
    }
    .MuiFormHelperText-root {
        @media (max-width: 768px) {
            margin-bottom: 10px;
        }
    }
`;

export const CustomRadioInput: any = styled(EditableInput)`
    .MuiFormLabel-root {
        @media (max-width: 768px) {
            position: relative;
            margin-bottom: 20px;
            white-space: normal;
            font-size: 16px !important;
        }
    }
    .MuiFormGroup-row {
        @media (max-width: 768px) {
            flex-direction: column;
        }
    }
    .MuiFormControlLabel-root {
        @media (max-width: 768px) {
            &:not(:last-child) {
                margin-bottom: 20px;
            }
        }
    }
    .MuiFormControlLabel-label {
        @media (max-width: 768px) {
            font-size: 16px;
        }
    }
    .MuiRadio-colorSecondary.Mui-checked {
        color: ${theme.palette.hightownBlue.main};
    }
`;

export const CustomCheckbox: any = styled(EditableInput)`
    .MuiFormLabel-root {
        @media (max-width: 768px) {
            position: relative;
            margin-bottom: 20px;
            white-space: normal;
            font-size: 16px !important;
        }
    }
    .MuiFormControlLabel-root {
        color: ${theme.palette.text.primary} !important;
        position: relative;
    }
    .MuiCheckbox-colorSecondary.Mui-checked {
        color: ${theme.palette.hightownBlue.main};
    }

    .MuiFormHelperText-root {
        position: absolute;
        top: 30px;
        left: 40px;
        width: 600px;
        font-size: 12px;
        @media (max-width: 568px) {
            width: 300px;
        }
    }
`;
